// STEP 11d · A6 (#116 Q-C3a-2a, owner: YES) — a W9 amount typed with a reason is replaced by the lines only after a confirm.
// Any request that would refresh such an amount ("send again" on a worksheet, a link or an unlink) comes back 409
// MISSTATEMENT_AMOUNT_TYPED with the typed amount and the new one. lib/api.js hands that error here: the user is asked
// "This replaces the typed amount <x>…" (EN + AR, the server's own text); on Replace the confirm is recorded
// (POST …/misstatements/{id}/amount/release, Audit Trail) and the SAME request is sent once more; on Cancel nothing changes
// and toErrMsg says the typed amount is kept. One place for every worksheet — no screen handles it on its own.
import { askConfirm } from "@/lib/appDialog";
import I18N from "@/lib/i18n/1995_s11d1b_finance";

export const TYPED_CODE = "MISSTATEMENT_AMOUNT_TYPED";

const lang = () => {
  try { return (typeof localStorage !== "undefined" && localStorage.getItem("af_lang")) === "ar" ? "ar" : "en"; } catch { return "en"; }
};
const T = () => I18N[lang()].s11d1b.amount;

export function isTypedAmountError(err) {
  return err?.response?.status === 409 && err?.response?.data?.error_code === TYPED_CODE;
}

/** Returns a promise of the retried response (Replace), or null (not this error / Cancel / already retried). */
export async function handleTypedAmount(err, api) {
  const cfg = err?.config || {};
  if (!isTypedAmountError(err) || cfg._typedRetried) return null;
  const d = err.response.data || {};
  const msg = lang() === "ar" ? (d.detail_ar || d.detail) : d.detail;
  const ok = await askConfirm(msg, { title: T().confirmTitle, okLabel: T().confirmOk });
  if (!ok) { err._typedKept = true; return null; }
  await api.post(`/engagements/${d.engagement_id}/misstatements/${d.misstatement_id}/amount/release`, null, { _silent: true });
  return api.request({ ...cfg, _typedRetried: true });
}

export { typedKeptText, typedKeptMessage } from "@/lib/typedAmountKept";   // Step 12 add-on G6.1: one helper
